import React, { FunctionComponent, useEffect, useRef, useCallback, ChangeEvent } from 'react';
import { Presentation } from './presentation';
import type { Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  const focusRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if ($(window).width() && $(window).width()! > 767 && props.isOpen) {
      const timer = setTimeout(() => {
        focusRef.current?.focus();
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [props.isOpen]);

  const handleIndustryChange = useCallback(
    (industryId: string) => {
      props.onIndustryChange(Number(industryId));
    },
    [props.onIndustryChange]
  );

  const onCompanyNameChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      props.onCompanyNameChange(e);
    },
    [props.onCompanyNameChange]
  );

  const presentationProps = {
    ...props,
    focusRef,
    onCompanyNameChange,
    handleIndustryChange,
  };

  return <Presentation {...presentationProps} />;
};
